import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    configuration: [],
}

const configSlice = createSlice({
    name: 'configuration',
    initialState: initialState,
    reducers: {
        saveConfigData: (state, action) => {
            state.configuration = action.payload;
        },
        saveChannelData: (state, action) => {
            state.configuration = action.payload;
        },
        saveStdPriority: (state, action) => {
            state.configuration.stdFilesPriority = action.payload;
        },
        saveInnerData: (state, action) => {
            // const { key, payload } = action.payload;
            // const keyIndex = state.configuration.findIndex(item => Object.keys(item).includes(key));
            // if(keyIndex !== -1){
            //     state.configuration[keyIndex][key].push({standardFiles:payload});
            // }
            const payloadArray = action.payload;
            payloadArray.forEach(item => {
                state.configuration[item.name] = item;
            });

        },
    }
})

export default configSlice.reducer;
export const {saveConfigData,saveStdPriority, saveInnerData,saveChannelData} = configSlice.actions;